import { select, takeLatest, call, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';

import {
  bootstrapLoginAutomatedLoaded,
  bootstrapLoginAutomatedError
} from './actions';

import {
  BOOTSTRAP_LOGIN_AUTOMATED
} from './constants';

import {
  selectInitialDataConfig
} from './selectors';

import TerraService from '../../services/TerraService';
import Oauth2Service from '../../services/Oauth2Service';

function* bootstrapLoginAutomated() {

  try {
    const state = yield select();
    const config = selectInitialDataConfig(state);
    // eslint-disable-next-line
    const TBX_AUTO_LOGIN_ENABLE = process.env.TBX_AUTO_LOGIN_ENABLE || (window.AppENV && window.AppENV.TBX_AUTO_LOGIN_ENABLE);

    /**
     *
     * In case is disable autologin, redirect to login/pin
     *
     */
    // eslint-disable-next-line
    if (TBX_AUTO_LOGIN_ENABLE === 'false') {
      return yield put(push('/login/pin'));
    }

    /**
     *
     * Get values from TerraApi
     *
     */
    const terraData = yield call(TerraService.getMsisdnAndPin, config.terra_key, config.data);

     /**
      *
      * Evaluate if start manual access or get permission
      *
      */
    if (!terraData.ok) {
      yield put(push('/login/pin'));
    } else {
      const oAuth2data = yield call(Oauth2Service.authorize, config, terraData, true);
      // * get code from authorize
      if (oAuth2data.code) {
        const hasState = config.state ? `&state=${config.state}` : '';
        // * redirect to uri if all ok
        yield put(window.location.assign(`${config.redirect_uri}?code=${oAuth2data.code}${hasState}`));
      } else if (oAuth2data.error_description === 'ACCESS_DENIED') {
          yield put(push('/login/without_subscription'));
      } else {
        yield put(push('/login/pin'));
      }
    }

    return yield put(bootstrapLoginAutomatedLoaded());
  } catch (error) {
    // console.log(error);

    return yield put(bootstrapLoginAutomatedError(error));

  }
}

function* apiData() {
  yield takeLatest(BOOTSTRAP_LOGIN_AUTOMATED, bootstrapLoginAutomated);
}

export default apiData;



// WEBPACK FOOTER //
// ./src/containers/LoginAutomatedPage/sagas.js